import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum InstallmentStatus {
  Generated = 1,
  InProgress = 2,
  Paid = 3,
  Canceled = 4,
  Defaulter = 5,
  Accredit = 6,
  ChargebackRequested = 7,
  PaidByOtherWay = 8,
  RefundRequestOpened = 9,
  RefundInProgress = 10,
  Refunded = 11,
  CancelRequested = 12,
  UpdateRequested = 13,
  RefundedPartial = 14,
  RefundRequest = 15,
  RefundedByOtherWay = 16,
}
EnumDescriptions.setDescriptions(InstallmentStatus, [
  i18n.t('enums.generated'),
  i18n.t('enums.in_progress'),
  i18n.t('enums.paid'),
  i18n.t('enums.canceled'),
  i18n.t('enums.defaulter'),
  i18n.t('enums.accredit'),
  i18n.t('enums.chargeback_requested'),
  i18n.t('enums.paid_by_other_way'),
  i18n.t('enums.refund_request_opened'),
  i18n.t('enums.refund_in_progress'),
  i18n.t('enums.refunded'),
  i18n.t('enums.cancel_requested'),
  i18n.t('enums.update_requested'),
  i18n.t('enums.refunded_parcial'),
  i18n.t('enums.refund_request'),
  i18n.t('enums.refunded_by_other_way'),
]);
